import type { Socket } from 'socket.io-client'
import SocketIO from 'socket.io-client'

export default defineNuxtPlugin({
  name: 'socket-io',
  setup: (nuxtApp) => {
    const requestURL = useRequestURL()
    const WS_URL = useRuntimeConfig().public.ws || `wss://${requestURL.host}`
    const WS_APP = useRuntimeConfig().public.wsApp

    const io: Socket = SocketIO(WS_URL, {
      transports: ['websocket', 'polling'],
      path: '/ws',
      autoConnect: false,
      query: { app: WS_APP },
    })

    nuxtApp.vueApp.provide('io', io)
    useInitSocketsLogger(io)

    return {
      provide: {
        io,
      },
    }
  },
})
